import React, { useState } from 'react';
import LifeGHKimage from './images/LifeGHK.png';
import './campus.css';
import { images } from './LifeGHKDatabase';

const LifeGHK = () => {
  const [idx, setIdx] = useState(0);

  const handleClick = (index) => {
    setIdx(index);
  };

  return (
    <div>
      <img src={LifeGHKimage} className='mainImage' />
      <div className='navLifeGHK'>
        <div className={idx === 0 ? 'inner-life-ghk active' : 'inner-life-ghk'} onClick={() => handleClick(0)}>
          <h2>DIWALI CAMP / SUMMER CAMP ACTIVITIES</h2>
        </div>
        <div className={idx === 1 ? 'inner-life-ghk active' : 'inner-life-ghk'} onClick={() => handleClick(1)}>
          <h2>GIRL GUIDES / SCOUTS</h2>
        </div>
        <div className={idx === 2 ? 'inner-life-ghk active' : 'inner-life-ghk'} onClick={() => handleClick(2)}>
          <h2>WORKSHOPS AND SEMINAR</h2>
        </div>
        <div className={idx === 3 ? 'inner-life-ghk active' : 'inner-life-ghk'} onClick={() => handleClick(3)}>
          <h2>INTER-SCHOOL COMPETITIONS</h2>
        </div>
        <div className={idx === 4 ? 'inner-life-ghk active' : 'inner-life-ghk'} onClick={() => handleClick(4)}>
          <h2>COMPETITIVE EXAMS</h2>
        </div>
      </div>
      <img src={images[idx].img} className='LifeGHKDescription' />
    </div>
  );
};

export default LifeGHK;